// Generic CSV builder + browser download. Callers supply headers and rows of
// already-stringified cells; quoting/escaping is handled here.
const escapeCell = (value: string): string =>
  /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;

export const downloadCsv = (
  headers: string[],
  rows: string[][],
  filename: string,
): void => {
  const content = [headers, ...rows]
    .map((cols) => cols.map(escapeCell).join(","))
    .join("\n");

  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
